import React, { useEffect, useState } from "react";
import { CheckCircle2, XCircle, Loader2, Plug } from "lucide-react";
import { getIntegrationsStatus } from "../../api";

const AdminApiDirectory = () => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(true);
  useEffect(() => { getIntegrationsStatus().then(setData).catch(() => setData(null)).finally(() => setBusy(false)); }, []);

  if (busy) return <div className="flex items-center justify-center py-24 text-[#8a8a8a]"><Loader2 className="animate-spin mr-2" size={18} /> Checking integrations…</div>;
  if (!data) return <div className="bg-white rounded-2xl border border-[#f0ece5] p-8 text-center text-[#8a8a8a]">Couldn't load integrations.</div>;

  return (
    <div data-testid="admin-api-directory">
      <div className="flex items-center gap-3 mb-6">
        <span className="w-11 h-11 rounded-xl bg-[#faf7f2] flex items-center justify-center"><Plug size={20} className="text-[#b8935f]" /></span>
        <div>
          <h3 className="font-display text-[20px] font-500 text-[#2b2b2b]">APIs & integrations</h3>
          <p className="text-[13px] text-[#8a8a8a]">{data.connected} of {data.total} connected · every third-party wired into the platform</p>
        </div>
      </div>
      {data.categories.map((cat) => (
        <div key={cat} className="mb-6">
          <p className="text-[12px] uppercase tracking-[0.14em] text-[#b8935f] mb-3">{cat}</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {data.integrations.filter((i) => i.category === cat).map((i) => (
              <div key={i.key} className="bg-white rounded-xl border border-[#f0ece5] p-4" data-testid={`integration-${i.key}`}>
                <div className="flex items-start justify-between gap-2">
                  <p className="text-[14px] font-500 text-[#2b2b2b]">{i.name}</p>
                  {i.configured
                    ? <span className="flex items-center gap-1 text-[11px] text-green-600 shrink-0"><CheckCircle2 size={14} /> Connected</span>
                    : <span className="flex items-center gap-1 text-[11px] text-gray-400 shrink-0"><XCircle size={14} /> Not set</span>}
                </div>
                <p className="text-[12px] text-[#8a8a8a] mt-1.5">{i.use}</p>
                {i.detail && <p className="text-[11px] text-[#b8935f] mt-1.5">{i.detail}</p>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminApiDirectory;
